module.exports = __webpack_public_path__ + "img/quit.3f2821e6.svg";